import { FlatForm,  mandatoryValidator } from "../../../helpers/FormHelper";


export const getLidInstallationForm = (formName, context) => {

    const result = new FlatForm(formName, context);

    result.initialise([
        "id",
        "installationType",
        "isLidTelemetry",
        "telemetryType",
        "lid",
        "isFirstMeterForLID",
        "existingLid",
        "lidVendor",
        "formVersion",
        "lidInstallationStatus",
        "meterType",
        "meterScalingFactor",
        "iccid",
        "iccidOriginal",
        "iccidModifiedBy"
    ])
    .setValueChangedValidators({})
    .setPostChangeActions({})
    ;
    return result;
}

export const getSimCardChangeForm = (formName, context, saveAction, revertAction) => {
    const result = new FlatForm(formName, context);
    result.initialise([
        "id",
        "iccid"
    ])
    .setValueChangedValidators({})
    .setPostChangeActions({})
    .defineAction('save',saveAction,{
        iccid : [mandatoryValidator("This is required")]
    })
    .defineAction('revert',revertAction,{
    })
    ;
    return result;
}